import React from 'react';
import { Circle, CircleDot, Check, Archive, PackageCheck } from 'lucide-react';
import { cn } from '@/lib/utils';
import { statusMeta } from '@/lib/severity';
import './primitives.css';

const ICONS = {
  new: CircleDot,
  triage: Circle,
  acked: Check,
  shipped: PackageCheck,
  archived: Archive,
};

/**
 * Workflow status chip (new / triage / acked / shipped / archived).
 * Outlined with an icon so it never reads as a severity.
 * Also accepts useBriefStatus' 'unread'.
 */
export default function StatusBadge({ status, size = 'md', className, ...rest }) {
  const meta = statusMeta(status);
  const Icon = ICONS[meta.key];
  return (
    <span
      className={cn('is-badge is-badge--plain is-status-badge', size === 'sm' && 'is-badge--sm', className)}
      style={{ '--status-color': meta.color, '--status-bg': meta.bg, '--status-border': meta.border }}
      {...rest}
    >
      <Icon aria-hidden="true" />
      {meta.label}
    </span>
  );
}
